import { FileViewer, type FileSource } from '@powerportalspro/react-fluent';

const source: FileSource = {
  kind: 'bytes',
  value: new Uint8Array([1, 2, 3, 4]),
  fileName: 'data.bin',
};

export function FileViewerUnsupportedSample() {
  return <FileViewer source={source} fileName="data.bin" />;
}
